import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Typography } from '@lyearn/ui';
import { getDescString } from '@/modules/1on1s/views/1on1Details/components/Header/utils';

import { useLearningContent } from '../context';
import { RecurrenceScheduleProps } from '../types';
import { isRecurringSessionContent } from '../utils';

function RecurrenceSchedule({
  color = 'text-text-secondary',
  variant = 'body-short-02',
}: RecurrenceScheduleProps) {
  const { t } = useTranslation();
  const { content } = useLearningContent();

  const recurrenceSchedule = content.event?.recurrenceSchedule;

  if (isRecurringSessionContent(content.type) && recurrenceSchedule) {
    return (
      <Typography color={color} variant={variant}>
        {getDescString(t, recurrenceSchedule)}
      </Typography>
    );
  }

  return null;
}

export default React.memo(RecurrenceSchedule);
